export function createNotificationRealtimeConnection({url,token,onMessage,isAvailable,Socket=WebSocket,setTimer=setTimeout,clearTimer=clearTimeout}) {
    let socket=null,timer=null,disposed=false,attempt=0;
    const connect=()=>{
        if(disposed||!isAvailable()||socket&&[0,1].includes(socket.readyState))return;
        if(timer!==null){clearTimer(timer);timer=null;}
        socket=new Socket(url,['realtime',token]);
        socket.onopen=()=>{attempt=0;};
        socket.onmessage=event=>{if(!disposed)onMessage(event);};
        socket.onclose=()=>{
            if(disposed||!isAvailable())return;
            timer=setTimer(()=>{timer=null;connect();},Math.min(30000,1000*2**Math.min(attempt++,5)));
        };
    };
    return {connect,dispose(){disposed=true;if(timer!==null)clearTimer(timer);socket?.close();}};
}
